import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { provideHttpClient } from '@angular/common/http';

import { modalInputComponent } from '../modules/alert';
import { modalAlertComponent } from '../modules/alert';
import { UiKioskBoardComponent } from '../modules/kiosk';
import { UiKioskInputDirective } from '../modules/kiosk';
import { modalAwayComponent } from '../modules/geocode'
import { UiAwayComponent } from '../modules/geocode'

@NgModule({
    declarations: [
        modalInputComponent,
        modalAlertComponent,
        UiKioskBoardComponent,
        UiKioskInputDirective,
        modalAwayComponent,
        UiAwayComponent
    ],
    imports: [
        CommonModule, 
        IonicModule.forRoot(),
        IonicStorageModule.forRoot()
    ],
    exports: [
        UiKioskInputDirective,
        UiKioskBoardComponent
    ],
    providers: [
        HTTP,
        Network,
        AndroidPermissions,
        Geolocation,
        provideHttpClient()
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class UppBaseModule {}